module.exports = __webpack_public_path__ + "static/media/nfc.82d086a8.svg";